import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, Shield, FileText, Cookie, Calendar } from 'lucide-react';

const Footer = () => {
  return (
         <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-auto">
       <div className="container mx-auto px-4 py-6">
         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
           {/* App Info */}
           <div>
             <div className="flex items-center space-x-2 mb-3">
               <img
                 src="https://i.ibb.co/W799Y7W/decadesgif.webp"
                 alt="Decades Logo"
                 className="w-6 h-6 object-contain"
                 onError={(e) => {
                   e.target.style.display = 'none';
                 }}
               />
               <span className="text-base font-bold text-gray-900 dark:text-gray-100">BoTC Signup</span>
             </div>
             <p className="text-sm text-gray-600 dark:text-gray-400">
               A dedicated event management platform for Blood on the Clocktower games.
             </p>
           </div>

           {/* Quick Links */}
           <div>
             <h3 className="text-xs font-semibold text-gray-900 dark:text-gray-100 uppercase tracking-wider mb-3">
               Quick Links
             </h3>
             <ul className="space-y-1">
               <li>
                 <Link
                   to="/events"
                   className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center space-x-2 text-sm"
                 >
                   <Calendar size={14} />
                   <span>Events</span>
                 </Link>
               </li>
               <li>
                 <Link
                   to="/faq"
                   className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center space-x-2 text-sm"
                 >
                   <HelpCircle size={14} />
                   <span>FAQ</span>
                 </Link>
               </li>
             </ul>
           </div>

           {/* Legal */}
           <div>
             <h3 className="text-xs font-semibold text-gray-900 dark:text-gray-100 uppercase tracking-wider mb-3">
               Legal
             </h3>
             <ul className="space-y-1">
               <li>
                 <Link
                   to="/privacy-policy"
                   className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center space-x-2 text-sm"
                 >
                   <Shield size={14} />
                   <span>Privacy Policy</span>
                 </Link>
               </li>
               <li>
                 <Link
                   to="/terms-of-use"
                   className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center space-x-2 text-sm"
                 >
                   <FileText size={14} />
                   <span>Terms of Use</span>
                 </Link>
               </li>
               <li>
                 <Link
                   to="/cookie-policy"
                   className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center space-x-2 text-sm"
                 >
                   <Cookie size={14} />
                   <span>Cookie Policy</span>
                 </Link>
               </li>
             </ul>
           </div>
         </div>

         <div className="border-t border-gray-200 dark:border-gray-700 mt-6 pt-4">
           <div className="flex flex-col md:flex-row justify-between items-center">
             <p className="text-gray-500 dark:text-gray-400 text-xs">
               © {new Date().getFullYear()} Blood on the Clocktower Event Signup. All rights reserved.
             </p>
             <p className="text-gray-500 dark:text-gray-400 text-xs mt-1 md:mt-0">
               Powered by Discord OAuth • Built with React
             </p>
           </div>
         </div>
       </div>
     </footer>
  );
};

export default Footer; 